module.exports = __webpack_public_path__ + "img/interface OneB Url-editor_3 prew.0d6b042e.jpg";